module.exports = __webpack_public_path__ + "static/media/gorne-we.5547dd31.svg";